module.exports = __webpack_public_path__ + "static/media/md-radio-button-off.4b712f4f.svg";